import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import DialogWithCloseIcon from '@/components/ui/dialogs/dialog-with-close-icon';
import ParticipantAvatar, {
  Participant
} from '@/components/participant/participant-avatar';
import { useTranslation } from 'react-i18next';

interface AllAvatatarsDialogProps {
  open: boolean;
  onClose: () => void;
  participants: Participant[];
  onAvatarClick: (userId: string) => void;
}

const AllAvatatarsDialog: React.FC<AllAvatatarsDialogProps> = ({
  open,
  onClose,
  participants,
  onAvatarClick
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <DialogWithCloseIcon open={open} onClose={onClose} maxWidth="sm">
      <Typography
        variant={isMdUp ? 'h5' : 'h6'}
        component="div"
        align="center"
        gutterBottom
        marginBottom={3}
      >
        {t('participants_screen')}
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center">
        {participants.map((participant, index) => (
          <Box
            key={participant._id}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            marginBottom={2}
          >
            <ParticipantAvatar
              participant={participant}
              index={index}
              onClick={() => onAvatarClick(participant._id)}
            />
            <Box minWidth={300} maxWidth={300} sx={{ wordWrap: 'break-word' }}>
              <Typography variant="body1" textAlign="center">
                {participant.name}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </DialogWithCloseIcon>
  );
};

export default AllAvatatarsDialog;
